import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import "./CourseList.css";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import { Loading } from "../../Other/Loading";
const StudentList = lazy(() =>
  import("./CreateCourse/CourseListSection/StudentCourseList")
);
const AdminCourseList = lazy(() =>
  import("./CreateCourse/CourseListSection/AdminCourseList")
);
const CourseInstructor = lazy(() =>
  import("./CreateCourse/CourseListSection/CourseListInstructor")
);
function CourseList(props) {
  const parseAndShortDescription = (description) => {
    const parsed = description?.replace(/<[^>]*>/g, "");
    if (parsed?.length > 180) {
      const shortenend = parsed?.slice(0, 280);
      return shortenend;
    }
    return parsed;
  };
  return (
    <>
      <AuthorizedWrapper authorizedRoles={["Instructor"]}>
        <Suspense fallback={<Loading />}>
          <CourseInstructor
            parseAndShortDescription={parseAndShortDescription}
          />
        </Suspense>
      </AuthorizedWrapper>
      <AuthorizedWrapper authorizedRoles={["Admin", "Institute"]}>
        <Suspense fallback={<Loading />}>
          <AdminCourseList
            parseAndShortDescription={parseAndShortDescription}
          />
        </Suspense>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Student"]}>
        <Suspense fallback={<Loading />}>
          <StudentList parseAndShortDescription={parseAndShortDescription} />
        </Suspense>
      </AuthorizedWrapper>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    courses: state.course.myCourses || [],
    user: state.users?.user,
  };
};

export default connect(mapStateToProps)(CourseList);
